import type { ClientFlowAction } from '~/graphql/types.client';

const hasSingleConnectedBranch = (
  actions: Array<ClientFlowAction>,
): boolean => {
  if (actions.length <= 1) return true;

  const ids = new Set(actions.map(a => a.id));

  // Build children map
  const children = new Map<string, Set<string>>(
    actions.map(a => [a.id, new Set()]),
  );
  for (const action of actions) {
    if (
      'parentIds' in action &&
      action.parentIds[0] &&
      ids.has(action.parentIds[0])
    ) {
      children.get(action.parentIds[0])?.add(action.id);
    }
    if (action.__typename === 'FlowV2_Action_IfElse') {
      for (const childId of [action.trueChildId, action.falseChildId]) {
        if (childId && ids.has(childId)) children.get(action.id)!.add(childId);
      }
    }
  }

  const roots = actions.filter(
    a => !('parentIds' in a) || !a.parentIds[0] || !ids.has(a.parentIds[0]),
  );
  if (roots.length !== 1) return false;

  const visited = new Set<string>();
  const queue = [roots[0].id];
  while (queue.length > 0) {
    const id = queue.shift()!;
    if (visited.has(id)) continue;
    visited.add(id);
    for (const childId of children.get(id) ?? []) queue.push(childId);
  }

  return visited.size === actions.length;
};

export default hasSingleConnectedBranch;
